export enum MESSAGE_KIND {
  EMPLOYER_SETTINGS_COMMITTED = 'employerSettingsCommitted',
  EMPLOYER_SETTINGS_UPDATED = 'employerSettingsUpdated',
  LOADED = 'loaded',
  MFA_VERIFICATION_COMPLETED = 'mfa_verification:complete',
  ONBOARDING_SESSION_COMMITTED = 'onboardingSessionCommitted',
  ONBOARDING_STEP_CHANGED = 'onboardingStepChanged',
  ONBOARDING_SESSION_FINISHED = 'onboardingSessionFinished',
  TOAST = 'toast',
  WINDOW_DIMENSION_CHANGE = 'windowDimensionChange',
}
